export default __webpack_public_path__ + "static/8_34-491d8484514188ae9c4bad49fe065d22.png";